module.exports = __webpack_public_path__ + "img/55800.b2b5b403.jpg";